module.exports = __webpack_public_path__ + "static/media/8.10cb15b3.png";